
import Vue from "vue";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

export default Vue.extend({
  name: "PhonePicker",

  components: {
    VueTelInput
  },

  props: {
    value: {
      required: true
    },
    label: {
      required: false,
      type: String,
      default: ""
    },
    rules: {
      required: false,
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    phone: {} as object,
    phoneNumber: "" as string,
    focus: false
  }),

  watch: {
    value: {
      immediate: true,
      handler() {
        if (this.value) {
          this.phoneNumber = (this.value as string).slice(1);
        }
      }
    }
  },

  methods: {
    input(_: string, phoneObject: any) {
      if (typeof phoneObject.valid == "undefined") {
        return;
      }

      this.phone = phoneObject;

      if (phoneObject.valid) {
        this.$emit("input", phoneObject.number);
      } else {
        this.$emit("input", "");
      }
    }
  }
});
